export default class UpdateSiteRequest {
  constructor(
    public code: string,
    public name: string,
    public companyName: string | undefined,
    public address: string | undefined,
    public contactName: string | undefined,
    public email: string | undefined,
    public phone: string | undefined
  ) {}
}
